// DonationMasterItem.jsx
import { Box, IconButton, Tooltip } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { Fragment, useContext } from "react";
import { Copy, Plus } from "react-feather";
import {
  Card,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
  Table,
} from "reactstrap";
import { ACCOUNT_TYPE, DONATION_MASTER, Style } from "../../constant";
import DonationMasterContext from "../../context/DonatoinMasterContext/DonationMasterContext";
import DataNotFound from "../../DataNoteFound/DataNotFound";
import Switch from "react-js-switch";
import Breadcrumbs from "../../layout/breadcrumb";
import { useNavigate } from "react-router";
import { classes } from "../../data/layouts";
import OrgContext from "../../context/OrgContext/OrgContext";
import TableMenuItem from "../../utils/TableMenuItem";
import ProductContext from "../../context/ProductContext/ProductContext";
import OrganizationContext from "../../context/OrganizationContext/OrganizationContext";
import TableSkeleton from "../../loader/TableSkeleton";
import { currencyFormat, MuiTabelStyle } from "../../utils/helper";

const OrganizationItem = (props) => {
  const {
    editHandle,
    showHandle,
    sorting,
    AddModel,
    setPage,
    setPageSize,
    pageSize,
    page,
    record,
    handleFilter,
    switch_onChange_handle,
  } = props;

  const { formvalue, setAccountId, filter, setpageNumber } = useContext(
    DonationMasterContext,
  );
  const { setBankId } = useContext(OrgContext);
  const { setPersonId } = useContext(ProductContext);
  const { responseLoader } = useContext(OrganizationContext);
  const history = useNavigate();

  const defaultLayoutObj = classes.find(
    (item) => Object.values(item).pop(1) === "compact-wrapper",
  );
  const layout =
    localStorage.getItem("layout") || Object.keys(defaultLayoutObj).pop();

  const StatementRedirect = (accountId) => {
    setBankId("");
    setPersonId("");
    history(`/Statement/Statement/${accountId}/account/${layout}`);
    setAccountId(accountId);
    setpageNumber(1);
  };

  // Copy URL for each trust in the trustDetail array
  const handleCopyUrl = (row) => {
    const { orgId, accountId, templeDetail, trustDetail } = row;
    const templeUuid = templeDetail?.templeUuid ?? "";

    if (!trustDetail?.length) {
      navigator.clipboard.writeText(
        `${window.location.origin}/mahotsav-donation/${orgId}/${templeUuid}////${accountId}`,
      );
      return;
    }

    // Build one URL per trust and copy all (newline separated)
    const urls = trustDetail.map(
      (t) =>
        `${window.location.origin}/mahotsav-donation/${orgId}/${templeUuid}/${t.trustUuid}/${t.bankDetails?.[0]?.bankId ?? ""}/${accountId}`,
    );
    navigator.clipboard.writeText(urls.join("\n"));
  };

  const defaultColumns = [
    {
      flex: 0.15,
      minWidth: 180,
      field: "name",
      headerName: "Name",
      renderCell: (params) => params.row.name || "--",
    },
    {
      flex: 0.2,
      minWidth: 220,
      field: "trustDetail",
      headerName: "Trusts",
      sortable: false,
      renderCell: (params) => {
        const trusts = params.row.trustDetail;
        if (!trusts?.length) return "--";
        return (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 4,
              padding: "4px 0",
            }}
          >
            {trusts.map((t) => (
              <span
                key={t.trustUuid}
                style={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 99,
                  background: "#EEEDFE",
                  color: "#3C3489",
                  border: "0.5px solid #AFA9EC",
                  whiteSpace: "nowrap",
                }}
              >
                {t.trustName.trim()}
              </span>
            ))}
          </div>
        );
      },
    },
    {
      flex: 0.08,
      minWidth: 90,
      field: "type",
      headerName: "Type",
      renderCell: (params) => {
        const isInward = params.row.type === ACCOUNT_TYPE.inward;
        return (
          <span
            style={{
              fontSize: 11,
              padding: "2px 10px",
              borderRadius: 99,
              background: isInward ? "#E1F5EE" : "#FAECE7",
              color: isInward ? "#085041" : "#712B13",
              border: `0.5px solid ${isInward ? "#0F6E56" : "#993C1D"}`,
              fontWeight: 500,
            }}
          >
            {isInward ? ACCOUNT_TYPE.inward_name : ACCOUNT_TYPE.outward_name}
          </span>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 120,
      field: "defaultAmount",
      headerName: "Default amount",
      renderCell: (params) =>
        params.row.defaultAmount != null ? (
          <span style={{ color: "#888780", fontWeight: 500 }}>
            {currencyFormat(params.row.defaultAmount)}
          </span>
        ) : (
          "--"
        ),
    },
    {
      flex: 0.1,
      minWidth: 110,
      field: "amount",
      headerName: "Amount",
      renderCell: (params) =>
        params.row.amount != null ? (
          <span style={{ color: "#578b57", fontWeight: "bold" }}>
            {currencyFormat(params.row.amount)}
          </span>
        ) : (
          "--"
        ),
    },
    {
      flex: 0.1,
      minWidth: 110,
      field: "dueAmount",
      headerName: "Due amount",
      renderCell: (params) =>
        params.row.dueAmount != null ? (
          <span style={{ color: "#ff5f5f", fontWeight: "bold" }}>
            {currencyFormat(params.row.dueAmount)}
          </span>
        ) : (
          "--"
        ),
    },
    {
      flex: 0.07,
      minWidth: 80,
      field: "unit",
      headerName: "Unit",
      renderCell: (params) => params.row.unit || "--",
    },
    {
      flex: 0.08,
      minWidth: 90,
      field: "isActive",
      headerName: "Status",
      renderCell: (params) => (
        <Switch
          value={!!params.row.isActive}
          onChange={() =>
            switch_onChange_handle(params.row.accountId, params.row.isActive)
          }
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 120,
      sortable: false,
      renderCell: (params) => (
        <>
          <TableMenuItem
            params={params}
            editHandle={editHandle}
            showHandle={showHandle}
            StatementRedirect={StatementRedirect}
          />
          <Tooltip
            title={
              params.row.trustDetail?.length > 1
                ? "Copy all trust URLs"
                : "Copy URL"
            }
          >
            <IconButton
              aria-label="copy donation URL"
              onClick={() => handleCopyUrl(params.row)}
            >
              <Copy style={{ color: "green", width: 19, height: 19 }} />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <Fragment>
      <Breadcrumbs parent={DONATION_MASTER.DONATION_MASTER_PARENT} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <h3>{DONATION_MASTER.DONATION_MASTER_PARENT}</h3>
                <div
                  aria-label="add"
                  className="btn btn-primary"
                  onClick={AddModel}
                  style={Style}
                >
                  <Plus />
                </div>
              </CardHeader>

              <Table>
                <thead>
                  <tr>
                    <th>
                      <Row>
                        <Col md="2 mb-2">
                          <Input
                            className="form-control"
                            type="text"
                            placeholder="Search donation master..."
                            value={filter}
                            onChange={(e) => handleFilter(e)}
                          />
                        </Col>
                      </Row>
                    </th>
                  </tr>
                </thead>
              </Table>

              <Box
                sx={{
                  "& .even": { backgroundColor: "#f1f1f1" },
                  "& .odd": { backgroundColor: "white" },
                }}
              >
                {responseLoader ? (
                  <TableSkeleton />
                ) : formvalue?.length ? (
                  <DataGrid
                    autoHeight
                    pagination
                    sx={MuiTabelStyle}
                    rows={formvalue}
                    rowCount={record}
                    pageSize={pageSize}
                    getRowId={(row) => row.accountId}
                    columns={defaultColumns}
                    page={page - 1}
                    rowsPerPageOptions={[7, 10, 25, 50]}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPageNo) => setPage(newPageNo + 1)}
                    paginationMode="server"
                    disableSelectionOnClick
                    checkboxSelection={false}
                    sortingMode="server"
                    onSortModelChange={sorting}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "even"
                        : "odd"
                    }
                    rowHeight={52}
                  />
                ) : (
                  <DataNotFound />
                )}
              </Box>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default OrganizationItem;
